import memoize from "@-/com.npmjs.memoize";
import type { ContentDatabase } from "@-/dev.improve.haniverse.database.content";

let nextId = 0;

/** Function-valued handles disappear in TanStack JSON hashes; weak numeric IDs do not. */
export const getTileContentDatabaseId = memoize((_db: ContentDatabase) => nextId++, {
  cache: new WeakMap(),
});
